import { Button, EyeClosed, EyeOpen } from '@core/ui';
import { useTranslation } from 'react-i18next';

export const PasswordEyeIcon = ({ passwordType, onClick }: { passwordType: string; onClick: () => void }) => {
    const { t } = useTranslation();
    const isVisible = passwordType === 'text';

    return (
        <Button type="button" iconbtn classNames="group" onClick={onClick}>
            <span className="sr-only">{t(isVisible ? 'Account.Button.HidePassword' : 'Account.Button.ShowPassword')}</span>
            {isVisible ? <EyeOpen classNames="size-6 stroke-primary" /> : <EyeClosed classNames="size-6 stroke-primary" />}
        </Button>
    );
};
